// export const AUTH_API_BASE_URL = "http://localhost:8441/api/auth";

export const AUTH_API_BASE_URL = 'https://serve.malinditextiles.com/api/auth';